import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=1edb6c52&scoped=true&"
import script from "./PageTwo.vue?vue&type=script&lang=js&"
export * from "./PageTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb6c52",
  null
  
)

export default component.exports